import store from '@/store/index.js'
import { updateNodeStatus } from '@/store/nodeutl.js'
import { getLatestFundvalue } from '@/service/http.js'

/**
 * 开始所有定时任务
 */
export function startTasks() {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
        const intervalIds = []

        if (process.env.use_node) {
            updateNodeStatus()
            const m5 = setInterval(() => {
            // 更新节点状态
                updateNodeStatus()
            }, 1000 * 60 * 5)
            intervalIds.push(m5)
        }

        // //2分钟一次
        loadFundValue()
        const m2 = setInterval(() => {
            loadFundValue()
        }, 1000 * 60 * 2)
        intervalIds.push(m2)

        return resolve(intervalIds)
    })
}

/**
 * 更新后台基础信息
 */
function loadFundValue() {
    return new Promise((resolve, reject) => {
        getLatestFundvalue().then(res => {
            if (res.code == 200 && res.data) {
                const fdval = res.data.fundValue.toFixed(4)
                const fdmn = res.data.totalMoney.toFixed(4)
                const fdsup = res.data.totalFund.toFixed(4)
                const fddp = res.data.totalDisp.toFixed(4)
                store.commit('app/SET_FUNDVAL', fdval)
                store.commit('app/SET_FUNDMN', fdmn)
                store.commit('app/SET_TOTALSUP', fdsup)
                store.commit('app/SET_TOTALDISP', fddp)
                return resolve(true)
            } else {
                return reject(false)
            }
        })
    })
}



// WEBPACK FOOTER //
// ./src/utils/task.js